var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_3575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0333 3.33342C10.6845 3.46046 11.2829 3.77892 11.752 4.24804C12.2211 4.71716 12.5396 5.31559 12.6666 5.96675M10.0333 0.666748C11.3862 0.817039 12.6477 1.42286 13.6108 2.38475C14.5739 3.34664 15.1813 4.60742 15.3333 5.96008M14.6666 11.2801V13.2801C14.6674 13.4658 14.6294 13.6495 14.555 13.8196C14.4806 13.9898 14.3715 14.1425 14.2347 14.268C14.0979 14.3935 13.9364 14.4891 13.7605 14.5486C13.5846 14.608 13.3982 14.6301 13.2133 14.6134C11.1619 14.3905 9.19131 13.6895 7.45998 12.5667C5.8492 11.5432 4.48353 10.1775 3.45998 8.56675C2.33329 6.82755 1.63214 4.84741 1.41331 2.78675C1.39665 2.60239 1.41856 2.41659 1.47764 2.24116C1.53673 2.06574 1.63169 1.90454 1.75649 1.76783C1.88128 1.63112 2.03318 1.52189 2.2025 1.4471C2.37183 1.3723 2.55487 1.33359 2.73998 1.33341H4.73998C5.06351 1.33023 5.37717 1.4448 5.62248 1.65577C5.8678 1.86674 6.02803 2.15971 6.07331 2.48008C6.15772 3.12013 6.31428 3.74857 6.53998 4.35342C6.62967 4.59203 6.64908 4.85136 6.59591 5.10067C6.54274 5.34998 6.41922 5.57882 6.23998 5.76008L5.39331 6.60675C6.34235 8.27578 7.72428 9.65771 9.39331 10.6067L10.24 9.76008C10.4212 9.58084 10.6501 9.45731 10.8994 9.40414C11.1487 9.35097 11.408 9.37039 11.6466 9.46008C12.2515 9.68578 12.8799 9.84233 13.52 9.92675C13.8438 9.97244 14.1396 10.1356 14.351 10.3851C14.5624 10.6346 14.6748 10.9531 14.6666 11.2801Z",
    stroke: "#52525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_3575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.179da61046748cff61b7b29f7e65d4cb.svg";
export { ForwardRef as ReactComponent };